module.exports = __webpack_public_path__ + "img/plugin-bottom-left-dark.d68813e.svg";